import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { StaticFooterComponent } from '../../components/static-footer/static-footer.component';
import { StaticNavbarComponent } from '../../components/static-navbar/static-navbar.component';

@Component({
  selector: 'app-static-layout',
  standalone: true,
  imports: [RouterOutlet, StaticNavbarComponent, StaticFooterComponent],
  template: `
  <div class="site-layout-wrapper">
    <app-static-navbar></app-static-navbar>
    <main class="site-content">
      <router-outlet></router-outlet>
    </main>
    <app-static-footer></app-static-footer>
  </div>
    `,
})
export class StaticLayoutComponent {}
